import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getConfigItemNestedObjectValue", "getConfigItem"]),
    PRIMARY_COLOUR() {
      return this.getConfigItem("PRIMARY_COLOUR");
    },
    SECONDARY_COLOUR() {
      return this.getConfigItem("SECONDARY_COLOUR");
    },
    PRIMARY_COLOUR_TEXT() {
      return this.getConfigItem("PRIMARY_COLOUR_TEXT");
    },
    SECONDARY_COLOUR_TEXT() {
      return this.getConfigItem("SECONDARY_COLOUR_TEXT");
    },
    INFO_COLOUR_TEXT() {
      return this.getConfigItem("INFO_COLOUR_TEXT");
    },
    BTN_BACKGROUND_COLOUR() {
      return this.getConfigItem("BTN_BACKGROUND_COLOUR");
    },
    LEFT_ALIGNED_LIST_ITEM() {
      return this.getConfigItem("LEFT_ALIGNED_LIST_ITEM");
    },
    homeUrl() {
      return this.getConfigItemNestedObjectValue("HOME_URL", "url");
    },
    homeTitle() {
      return this.getConfigItemNestedObjectValue("HOME_URL", "title");
    },
    bookingUrl() {
      return this.getConfigItemNestedObjectValue("BOOKING_URL", "url");
    },
    bookingTitle() {
      return this.getConfigItemNestedObjectValue("BOOKING_URL", "title");
    },
    openingHoursUrl() {
      return this.getConfigItemNestedObjectValue("OPEN_HOUR_URL", "url");
    },
    openingHoursTitle() {
      return this.getConfigItemNestedObjectValue("OPEN_HOUR_URL", "title");
    },
  },
};
